const BASE_LEVEL_TABLE_DEFAULT_PROPS = Object.freeze({
  value: { type: Array, default: () => [] },
  name: { type: String, required: false },
  subtitle: { type: String, default: '' },
  headers: { type: Array, required: true },
  hideHeaders: { type: Array, required: false },
  formComponent: { type: String, required: false },
  path: { type: String, required: true },
  initialFilter: {
    type: Object, default: function () {
      return {};
    }
  },
  initialSortBy: {
    type: Array, default: () => []
  },
  initialSort: {
    type: Array, default: () => []
  },
  mandatoryFilters: {
    type: Object, default: function () {
      return {};
    }
  },
  getData: {
    type: Function,
    default: response => response.data?.data?.map(item => item.data)
  },
  numberOfEntriesColspan: { type: Number, required: false },
  invokedParamHandler: { type: Function },
  actionArray: { type: Array, required: false },
  handleNewSpecificAction: { type: Function, required: false },
  handleClickRow: { type: Function, required: false },
  configurableColumns: { type: Array, required: false },
  itemClass: { type: [String, Function], required: false },
  hasMaxHeight: { type: Boolean, default: false },
  isSearchable: { type: Boolean, default: true }
});

export default BASE_LEVEL_TABLE_DEFAULT_PROPS;
